<template>
  <div style="width: 100%; height: 100%">
    <div
      style="
        width: 0.5376vw;
        height: 100%;
        display: flex;
        float: left;
        background: rgba(240, 240, 240, 1);
      "
    ></div>
    <div style="width: 6%; height: 100%; float: left"></div>
    <div style="width: 93%; height: 100%; float: left">
      <div style="width: 100%; height: 4.5%"></div>
      <div
        style="width: 100%; height: 5.5%; align-items: center; display: flex"
      >
        <div
          style="
            width: 20%;
            height: 100%;
            float: left;
            align-items: center;
            display: flex;
          "
          class="v41_161"
        >
          <span v-if="Lflag == true" class="v35_1047" style="width: 15%"
            >羽流计算</span
          >
          <span
            v-if="Lflag == false"
            class="v35_1047"
            style="width: 15%"
          ></span>
        </div>
        <div
          style="
            width: 60%;
            height: 100%;
            float: left;
            align-items: center;
            display: flex;
          "
        ></div>
      </div>
      <div style="width: 97%; height: 2vh"></div>
      <div style="width: 97%; height: 80%">
        <div style="width: 33%; height: 100%; float: left">
          <div
            v-if="Calculation_flag == false"
            style="width: 100%; height: 100%"
          >
            <div style="width: 100%; height: 8%">
              <el-select
                v-model="sun"
                placeholder="请选择"
                style="width: 48%; float: left"
              >
                <el-option
                  v-for="item in option1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <div style="width: 4%; height: 100%; float: left"></div>
              <el-select
                v-model="Time"
                placeholder="时段"
                style="width: 48%; float: left"
              >
                <el-option
                  v-for="item in option2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div style="width: 100%; height: 1%"></div>
            风向：<el-input v-model="cloud"></el-input>
            <div style="width: 100%; height: 1%"></div>
            研究区域的经度范围：
            <div style="width: 100%">
              <el-input style="width: 45%" v-model="grid_lon1"></el-input>—
              <el-input style="width: 45%" v-model="grid_lon2"></el-input>
            </div>
            <div style="width: 100%; height: 1%"></div>
            研究区域的纬度范围：
            <div style="width: 100%">
              <el-input style="width: 45%" v-model="grid_lat1"></el-input>—
              <el-input style="width: 45%" v-model="grid_lat2"></el-input>
            </div>
            <div style="width: 100%; height: 1%"></div>
            排放源位置（经度）：<el-input v-model="xs"></el-input>
            <div style="width: 100%; height: 1%"></div>
            排放源位置（纬度）：<el-input v-model="ys"></el-input>
            <div style="width: 100%; height: 1%"></div>
            排放源海拔高度：<el-input v-model="hs"></el-input>
            <div style="width: 100%; height: 1%"></div>
            走航车海拔高度：<el-input v-model="z"></el-input>
            <div style="width: 100%; height: 1%"></div>
            地面粗糙度：<el-input v-model="z0"></el-input>
            <div style="width: 100%; height: 1%"></div>
          </div>
        </div>
        <div style="width: 5%; height: 100%; float: left"></div>
        <div style="width: 55%; height: 100%; float: left">
          <div
            style="width: 100%; height: 66%"
            id="container"
            class="container"
          ></div>
          <div style="width: 100%; height: 1%"></div>
          <div
            v-if="Calculation_flag == true"
            style="width: 100%; height: 33%; overflow: auto"
          >
            <el-table
              class="fixedtableHeight"
              ref="multipleTable"
              id="tableshow"
              height="500"
              :data="resultsList"
              style="width: 100%; margin-top: 1%"
            >
              <el-table-column
                :label="item.paramName"
                :property="item.paramIndex"
                v-for="item in titleList"
                :key="item.paramIndex"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row[scope.column.property] }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            v-if="Calculation_flag == false"
            style="width: 100%; height: 33%"
          >
            <div
              style="
                width: 100%;
                height: 30%;
                position: relative;
                float: right;
                display: flex;
                align-items: center;
                justify-content: right;
              "
            >
              <el-input v-model="name"></el-input>
              <div style="width: 30%"></div>
              <el-button
                type="botton"
                style="
                  background-color: rgba(25, 44, 250, 1);
                  padding-left: 2.0968vw;
                  padding-right: 2.0968vw;
                  padding-top: 0.6452vw;
                  padding-bottom: 0.6452vw;
                  align-items: center;
                  display: flex;
                  border-radius: 0.2688vw;
                  color: #fff;
                  font-family: Microsoft YaHei UI;
                  font-weight: Regular;
                  font-size: 0.8602vw;
                "
                @click="start()"
                >开始</el-button
              >
              <el-button
                type="botton"
                style="
                  background-color: rgba(25, 44, 250, 1);
                  padding-left: 2.0968vw;
                  padding-right: 2.0968vw;
                  padding-top: 0.6452vw;
                  padding-bottom: 0.6452vw;
                  align-items: center;
                  display: flex;
                  border-radius: 0.2688vw;
                  color: #fff;
                  font-family: Microsoft YaHei UI;
                  font-weight: Regular;
                  font-size: 0.8602vw;
                "
                @click="end()"
                >结束</el-button
              >
            </div>
            <div
              style="
                width: 100%;
                height: 30%;
                position: relative;
                float: left;
                display: flex;
                align-items: center;
                justify-content: left;
              "
            >
              <el-button
                type="botton"
                style="
                  background-color: rgba(25, 44, 250, 1);
                  padding-left: 2.0968vw;
                  padding-right: 2.0968vw;
                  padding-top: 0.6452vw;
                  padding-bottom: 0.6452vw;
                  align-items: center;
                  display: flex;
                  border-radius: 0.2688vw;
                  color: #fff;
                  font-family: Microsoft YaHei UI;
                  font-weight: Regular;
                  font-size: 0.8602vw;
                "
                @click="Calculation()"
                >计算排放源排放速率</el-button
              >
              <el-button
                type="botton"
                style="
                  background-color: rgba(25, 44, 250, 1);
                  padding-left: 2.0968vw;
                  padding-right: 2.0968vw;
                  padding-top: 0.6452vw;
                  padding-bottom: 0.6452vw;
                  align-items: center;
                  display: flex;
                  border-radius: 0.2688vw;
                  color: #fff;
                  font-family: Microsoft YaHei UI;
                  font-weight: Regular;
                  font-size: 0.8602vw;
                "
                @click="Calculation_results()"
                >查看计算结果</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div style="width: 97%; height: 6%">
        <el-button type="text" @click="return_interface()"
          ><span
            style="
              color: rgba(25, 44, 250, 1);
              font-family: Microsoft YaHei UI;
              font-weight: Regular;
              font-size: 0.8602vw;
            "
            >返回上一级</span
          ></el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { checkToken } from "@/api/user";
import { setstart } from "@/api/data";
import { setend } from "@/api/data";
import { ask_plume } from "@/api/data";
import { send_plume } from "@/api/data";
import { asksitelog, askLL } from "@/api/data";
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import XYZ from "ol/source/XYZ";
import { fromLonLat } from "ol/proj";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import { Style, Circle, Fill, Stroke } from "ol/style";
export default {
  data() {
    return {
      option1: [
        {
          value: "强",
          label: "强",
        },
        {
          value: "中",
          label: "中",
        },
        {
          value: "弱",
          label: "弱",
        },
      ],
      option2: [
        {
          value: "白天",
          label: "白天",
        },
        {
          value: "黑夜",
          label: "黑夜",
        },
      ],
      username: "",
      project: "",
      table: "",
      database: "",
      site: "",
      name: "",
      Lflag: true,
      zoom_num: "",
      Calculation_flag: false,
      sun: "",
      Time: "",
      cloud: "0.1",
      grid_lon1: "121",
      grid_lat1: "34",
      grid_lon2: "122",
      grid_lat2: "34.5",
      xs: "121.12345",
      ys: "34.12345",
      hs: "2",
      z: "3",
      z0: "0.1",
      map: null,
      concentration1: "",
      concentration2: "",
      concentration3: "",
      concentration4: "",
      time: "",
      wind: "",
      longitude: "",
      latitude: "",
      temperature: "",
      pressure: "",
      request_flag: false,
      loglist: [],
      resultsList: [],
      titleList: [],
    };
  },
  created() {
    this.Lflag = this.$store.state.Language;
    checkToken(this.$qs.stringify({ token: this.$store.state.token })).then(
      (res) => {
        console.log(res);
      }
    );
    this.username = this.$store.state.username;
    this.project = this.$store.state.project;
    this.concentration1 = 100;
    this.concentration2 = 200;
    this.concentration3 = 300;
    this.concentration4 = 400;
    this.time = "2024/7/8 12:00:00";
    this.wind = 100;
    // 从lonandlat表加载设备坐标
    const db = this.project[0];
    const table = this.$store.state.site;
    if (db && table) {
      askLL(this.$qs.stringify({ database: db, table: table })).then((res) => {
        if (res.data && res.data.length > 0 && res.data[0]) {
          const lon = Number(res.data[0].longitude);
          const lat = Number(res.data[0].latitude);
          if (lon !== 0 && lat !== 0 && !isNaN(lon) && !isNaN(lat)) {
            this.longitude = lon;
            this.latitude = lat;
          }
        }
      }).catch((err) => {
        console.warn("获取坐标失败:", err);
      });
    }
    this.temperature = 35;
    this.pressure = 100;
    this.database = this.project[0];
    this.site = this.$store.state.site;
    console.log(this.site);
    asksitelog(this.$qs.stringify({ site: this.site })).then((res) => {
      this.loglist = res.data;
      console.log(res.data);
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.initAMap();
    });
  },
  methods: {
    Calculation() {
      console.log(this.name);
      console.log(this.site);
      console.log(this.sun);
      console.log(this.cloud);
      console.log(this.grid_lon1);
      console.log(this.grid_lat1);
      console.log(this.grid_lon2);
      console.log(this.grid_lat2);
      console.log(this.xs);
      console.log(this.ys);
      console.log(this.Time);
      console.log(this.hs);
      console.log(this.z);
      console.log(this.z0);
      if (this.request_flag == true) {
        var keys = Object.keys(this.resultsList[0]);
        for (let i in keys) {
          this.titleList.push({ paramIndex: keys[i], paramName: keys[i] });
        }
        console.log(this.titleList);
      }
      send_plume(
        this.$qs.stringify({
          name: this.name,
          table: this.site,
          sun: this.sun,
          cloud: this.cloud,
          lon1: this.grid_lon1,
          lat1: this.grid_lat1,
          lon2: this.grid_lon2,
          lat2: this.grid_lat2,
          xs1: this.xs,
          ys1: this.ys,
          light: this.Time,
          hs: this.hs,
          z: this.z,
          z0: this.z0,
        })
      ).then((res) => {
        console.log(res);
      });
    },
    Calculation_results() {
      this.Calculation_flag = true;
      this.resultsList = [];
      this.titleList = [];
      console.log(this.name, this.site);
      ask_plume(this.$qs.stringify({ site: this.site, name: this.name })).then(
        (res) => {
          this.resultsList.push(res.data[0]);
          console.log(this.resultsList);
          this.request_flag = true;
          var keys = Object.keys(this.resultsList[0]);
          for (let i in keys) {
            this.titleList.push({ paramIndex: keys[i], paramName: keys[i] });
          }
          console.log(this.titleList);
        }
      );
    },
    return_interface() {
      if (this.Calculation_flag == true) {
        this.Calculation_flag = false;
      } else if (this.Calculation_flag == false) {
        this.$router.push("/Main/Cruise_monitoring_main");
      }
    },
    start() {
      var stamp = new Date().getTime() + 8 * 60 * 60 * 1000;
      var beijingTime = new Date(stamp)
        .toISOString()
        .replace(/T/, " ")
        .replace(/\..+/, "")
        .substring(0, 19);
      console.log(this.database);
      console.log(this.site);
      console.log(beijingTime);
      console.log(this.name);
      setstart(
        this.$qs.stringify({
          database: this.database,
          site: this.site,
          start: beijingTime,
          name: this.name,
        })
      ).then((res) => {
        console.log(res);
      });
    },
    end() {
      var stamp = new Date().getTime() + 8 * 60 * 60 * 1000;
      var beijingTime = new Date(stamp)
        .toISOString()
        .replace(/T/, " ")
        .replace(/\..+/, "")
        .substring(0, 19);
      console.log(this.database);
      console.log(this.site);
      console.log(beijingTime);
      console.log(this.name);
      setend(
        this.$qs.stringify({
          database: this.database,
          site: this.site,
          end: beijingTime,
          name: this.name,
        })
      ).then((res) => {
        console.log(res);
      });
    },
    initAMap() {
      // 天地图替代高德 - 用于羽流计算的参考地图展示
      const key = '336323d30619cd003065c070cf628bc3';
      const imgLayer = new TileLayer({
        source: new XYZ({
          url: `https://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${key}`,
          crossOrigin: 'anonymous',
        }),
      });
      const ciaLayer = new TileLayer({
        source: new XYZ({
          url: `https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${key}`,
          crossOrigin: 'anonymous',
        }),
      });
      const markerSource = new VectorSource();
      const markerLayer = new VectorLayer({ source: markerSource });
      this.map = new Map({
        target: 'container',
        layers: [imgLayer, ciaLayer, markerLayer],
        view: new View({
          center: fromLonLat([this.longitude || 0, this.latitude || 0]),
          zoom: 17,
        }),
      });
      // 标记羽流源位置
      if (this.longitude && this.latitude) {
        const feat = new Feature({
          geometry: new Point(fromLonLat([this.longitude, this.latitude])),
        });
        feat.setStyle(new Style({
          image: new Circle({
            radius: 8,
            fill: new Fill({ color: 'rgba(255, 80, 80, 0.9)' }),
            stroke: new Stroke({ color: '#fff', width: 2 }),
          }),
        }));
        markerSource.addFeature(feat);
      }
    },
  },
  destroyed() {
    if (this.map) {
      this.map.setTarget(null);
      this.map = null;
    }
  },
};
</script>
<style scoped>
::v-deep .el-button {
  padding-left: 0.0538vw;
  padding-top: 0.0538vw;
}
</style>
<style>
.btn {
  position: absolute;
  cursor: pointer;
  z-index: 10;
}
.description {
  height: 4.8387vh;
}

.edit {
  top: 53.7634vw;
  right: 5.3763vh;
}

.basic_info {
  resize: none;
  width: 80%;
  height: 2.1505vh;
}

.v41_170 {
  width: 5.1613vw;
  color: rgba(0, 0, 0, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 1.0753vw;
  opacity: 1;
  text-align: left;
}

.v41_172 {
  width: 6.8817vw;
  height: 2.7957vh;
  background: rgba(25, 44, 250, 1);
  padding: 0.5914vw 2.1505vw;
  margin: 0.5376vw;
  opacity: 1;
  border-top-left-radius: 0.2688vw;
  border-top-right-radius: 0.2688vw;
  border-bottom-left-radius: 0.2688vw;
  border-bottom-right-radius: 0.2688vw;
  overflow: hidden;
}

.v41_169 {
  width: 5.1613vw;
  color: rgba(25, 44, 250, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  opacity: 1;
  text-align: left;
}

.v41_168 {
  width: 2.5806vw;
  color: rgba(255, 255, 255, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  opacity: 1;
  text-align: left;
}

.v41_166 {
  width: 98%;
  height: 100%;
  background: rgba(243, 249, 255, 1);
  outline-color: rgba(243, 249, 255, 1);
  opacity: 1;
  padding: 0vw;
  border: 0vw;
  border-top-left-radius: 0.5376vw;
  border-top-right-radius: 0.5376vw;
  border-bottom-left-radius: 0.5376vw;
  border-bottom-right-radius: 0.5376vw;
  overflow: hidden;
  color: rgba(0, 0, 0, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  text-align: left;
}

.box-card .text {
  font-size: 0.7527vw;
}

.item {
  margin-bottom: 0.9677vw;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 43.0108vw;
}
</style>